export default "__VITE_PUBLIC_ASSET__420f1010__"